/* eslint-disable eqeqeq */
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { failedRequest, api, successRequest } from './constants';
import mutations from './mutations';
import state from './state';
import { postApi } from '../../../lib/fetcher';
import { atob, btoa } from '../../../lib/helpers';


const requestRefund = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {

      const URL_API = api.GET_LIST_REFUND_REQUEST;

      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();

      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sortValue = `${sortBy[0] ? sortBy[0] : 'rrn'} ${sort}`;
      const searchCopy = { ...search };

      if (searchCopy.trx_datetime.length == 2) {
        const d1 = Date.parse(search.trx_datetime[0]);
        const d2 = Date.parse(search.trx_datetime[1]);

        if (d1 > d2) {
          [searchCopy.trx_datetime[0], searchCopy.trx_datetime[1]] = [searchCopy.trx_datetime[1], searchCopy.trx_datetime[0]];
        }
      }

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: sortValue,
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, URL_API, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async requestRefund(ctx, { date, id, search }) {

      const URL_API = api.SEND_REFUND_REQUEST;

      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Request');
      ctx.commit('setProgressColor', 'green');

      const data = JSON.stringify({
        id,
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;

        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1); 
        }
      }, 100);
      
      ctx.commit('setIntervalRefund', intervalId);

      try {
        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          clearInterval(intervalId); 
          successRequest(ctx, responseData);

          return true;
        } 
        clearInterval(intervalId);

        return failedRequest(ctx, responseData); 
    
      } catch (error) {
        return failedRequest(ctx); 
      } finally {
        clearInterval(ctx.state.intervalRefund);
        ctx.commit('setIntervalRefund', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500); 
      }
    },

    closeProgressBar({ commit }) {
      commit('setShowProgressBar', false);
    },
  },
};

export default requestRefund;
